import React, { useState, useEffect, useRef } from 'react';
import PhoneInput from 'react-phone-number-input';
import { alphabetRegex } from '../utils/regexPatterns.jsx';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import FadeLoader from "react-spinners/FadeLoader";
import { checkEmailExistence, checkMobileExistence } from '../../Services/userService.js'
import { empRegistration, fetchEmpDetailsByEmailId, UpdateProfileByEntity, EmpRegistrationB2C } from '../../Services/ManagerService.jsx';
import BootstrapDialog from '../BootstrapDialog/BootstrapDialog.jsx';
import BootstrapDialogpopup from '../Owner/EmailConfirmationPopUpModel.jsx'
import { FcCheckmark } from "react-icons/fc";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ValidationMessages from "../utils/validationMessages.jsx";
import termsOfServicesData from '../TermsOfServices/TermsOfServices.json';
import termsOfUsesData from '../TermsOfServices/TermsOfUses.json'

const EmployeeRegistration = (props) => {
    const hostHeader = process.env.REACT_APP_CUSTOM_HEADER;
    const hostPath = process.env.REACT_APP_API_BASE_URL;
    const resetUrl = `${window.location.origin}/PasswordSetupPage`;

    const [loader, setLoader] = useState(false);
    const [dialogData, setDialogData] = useState({ title: '', sections: [] });
    const [open, setOpen] = useState(false);
    const [openpopup, setOpenmodel] = useState(false);
    const [EmailPopUp, setEmailPopUp] = useState(false);
    const [isemailVerified, setEmailverified] = useState(false);
    const [isphoneVerified, setPhoneVerified] = useState(false);
    const [, setPhoneVerification] = useState(false);
    const [InValidOTP, setInValidOTP] = useState("");
    const [OTPValidation, setOTPValidation] = useState("");
    const navigate = useNavigate();
    const [todayDate, setTodayDay] = useState(() => new Date());
    const [errors, setErrors] = useState({});
    const [, setShowPopup] = useState(false);


    const [formData, setFormData] = useState({
        FirstName: '',
        LastName: '',
        Title: "Employee",
        EmailId: '',
        MobileNumber: '',
        OfficeNumber: '',
        Password: 'Geoparking@123',
        ConfirmPassword: 'Geoparking@123',
        IsEmailVerified: false,
        IsPhoneVerified: false,
        TandC1: props.userDetails?.tandC1,
        TandC1CreatedDate: props.userDetails?.tandC1CreatedDate,
        TandC2: props.userDetails?.tandC2,
        TandC2CreatedDate: props.userDetails?.tandC2CreatedDate,
        IsTempPassword: false,
        IsReitOwner: props.userDetails?.isReitOwner,
        IsReitOwnerCreatedDate: props.userDetails?.isReitOwnerCreatedDate,
        EmpFirstName: props.userDetails?.empFirstName,
        EmpLastName: props.userDetails?.empLastName
    });
    const initialFormDataRef = useRef({});
    useEffect(() => {
        if (Object.keys(initialFormDataRef.current).length === 0) {
            initialFormDataRef.current = { ...formData };
        }
    }, []);

    useEffect(() => {
        if (!initialFormDataRef.current || Object.keys(initialFormDataRef.current).length === 0) {
            props.handleCancel(false);
            return;
        }
    }, [formData]);

    useEffect(() => {
        console.log("Hello World");

        const fetchOwnerdetails = async () => {
            setLoader(true);  // Show loader before fetching data

            try {
                const employeeDetails = await fetchEmpDetailsByEmailId(props.employeeEmailId);
                console.log("employeeDetails", employeeDetails);

                const newFormData = {
                    EmailId: employeeDetails?.emailId || formData.EmailId || props.employeeEmailId || "",
                    FirstName: employeeDetails?.firstName || employeeDetails?.empFirstName || formData.FirstName || "",
                    LastName: employeeDetails?.lastName || employeeDetails?.empLastName || formData.LastName || "",
                    MobileNumber: employeeDetails?.mobileNumber || formData.MobileNumber || "",
                    OfficeNumber: employeeDetails?.officeNumber || formData.OfficeNumber || "",
                    Title: employeeDetails?.title || formData.Title || "Employee",
                    IsEmailVerified: employeeDetails?.isEmailVerified ?? formData.IsEmailVerified ?? false,
                    IsPhoneVerified: employeeDetails?.isPhoneVerified ?? formData.IsPhoneVerified ?? false,
                    TandC1: employeeDetails?.tandC1 ?? formData.TandC1 ?? false,
                    TandC2: employeeDetails?.tandC2 ?? formData.TandC2 ?? false,
                    IsTempPassword: employeeDetails?.isTempPassword ?? formData.IsTempPassword ?? false,
                    IsReitOwner: employeeDetails?.isReitOwner ?? formData.IsReitOwner ?? false,
                    TandC1CreatedDate:
                        (employeeDetails?.tandC1)
                            ? (
                                employeeDetails.tandC1CreatedDate.trim?.()
                                    ? employeeDetails.tandC1CreatedDate
                                    : new Date().toLocaleString("en-US", {
                                        month: "numeric",
                                        day: "numeric",
                                        year: "numeric",
                                        hour: "numeric",
                                        minute: "numeric",
                                        second: "numeric",
                                        hour12: true,
                                    }).replace(",", "")
                            )
                            : "",

                    TandC2CreatedDate: employeeDetails?.tandC2
                        ? (employeeDetails?.tandC2CreatedDate?.trim?.()
                            ? employeeDetails.tandC2CreatedDate
                            : new Date().toLocaleString("en-US", {
                                month: "numeric",
                                day: "numeric",
                                year: "numeric",
                                hour: "numeric",
                                minute: "numeric",
                                second: "numeric",
                                hour12: true,
                            }).replace(",", ""))
                        : ""
                    ,

                    IsReitOwnerCreatedDate: employeeDetails?.isReitOwner
                        ? (employeeDetails?.isReitOwnerCreatedDate?.trim?.()
                            ? employeeDetails.isReitOwnerCreatedDate
                            : new Date().toLocaleString("en-US", {
                                month: "numeric",
                                day: "numeric",
                                year: "numeric",
                                hour: "numeric",
                                minute: "numeric",
                                second: "numeric",
                                hour12: true,
                            }).replace(",", ""))
                        : "",
                    AgreementFileName: employeeDetails?.agreementFileName || formData.AgreementFileName || '',
                    AgreementFileURL: employeeDetails?.agreementFileURL || formData.AgreementFileURL || '',
                    UploadRecordedVideoURL: employeeDetails?.videoUrl || formData.UploadRecordedVideoURL || '',
                    UploadedVideoFileName: employeeDetails?.videoFileName || formData.UploadedVideoFileName || ''
                };
                console.log("newFormData", newFormData);

                setFormData(newFormData);
                initialFormDataRef.current = newFormData;
                setPhoneVerified(employeeDetails?.isPhoneVerified);
                setEmailverified(employeeDetails?.isEmailVerified);

            } catch (error) {
                console.error("Error fetching owner details:", error);
                setTodayDay(new Date());
            } finally {
                setLoader(false);
            }
        };

        if (props.employeeEmailId) {
            fetchOwnerdetails();
        }
    }, [props.employeeEmailId]);



    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setFormData((prev) => ({ ...prev, [name]: value }));
        setErrors((prevErrors) => {
            const newErrors = { ...prevErrors };
            if (name === "EmailId" && ((/\S+@\S+\.\S+/.test(value)) || value === "")) {
                delete newErrors.EmailId;
                setEmailverified(false);
            }
            if (name === "MobileNumber") {
                setPhoneVerified(false);
                delete newErrors.MobileNumber;
            }
            if (["FirstName", "LastName"].includes(name) && alphabetRegex.test(value)) {
                delete newErrors[name];
            } if (name === "Title") {
                delete newErrors.Title
            }
            return newErrors;
        });
    };
    const validateEmailandphone = async (emailid, phonenumber) => {
        const newErrors = {};
        const { EmailId, MobileNumber } = formData;
        if (phonenumber) {
            const mobileExists = await checkMobileExistence(formData.MobileNumber)
            if (!MobileNumber) {
                newErrors.MobileNumber = ValidationMessages.phoneRequired;
            }
            else if (mobileExists && !props?.EmailIdOwner) {
                newErrors.MobileNumber = ValidationMessages.mobileNumberAlredyExist;
            } else {
                const phoneNumber = MobileNumber.replace(/\D/g, "");
                if (mobileExists && props?.EmailIdOwner) {
                    newErrors.MobileNumber = ValidationMessages.mobileNumberAlredyExist;
                }
                if (phoneNumber.length !== 11 || !phoneNumber.startsWith("1")) {
                    newErrors.MobileNumber = ValidationMessages.inValidPhone;
                }
            }
        } else if (emailid) {
            const emailExists = await checkEmailExistence(formData.EmailId);
            if (!EmailId || !/\S+@\S+\.\S+/.test(EmailId)) {
                newErrors.EmailId = ValidationMessages.validEmail;
            }
            else if (emailExists && !props?.employeeEmailId) {
                newErrors.EmailId = ValidationMessages.emailAlredyExist;
            }
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    }
    const validateForm = async (sec1, sec3) => {
        const newErrors = {};
        const { FirstName, LastName, Title, EmailId, MobileNumber, TandC2, TandC1, IsReitOwner } = formData;
        if (sec1) {
            const mobileExists = await checkMobileExistence(formData.MobileNumber)
            if (!MobileNumber) {
                newErrors.MobileNumber = ValidationMessages.phoneRequired;
            }
            else if (mobileExists && !props?.EmailIdOwner && !isphoneVerified) {
                newErrors.MobileNumber = ValidationMessages.mobileNumberAlredyExist;
            }
            else {
                const phoneNumber = MobileNumber.replace(/\D/g, "");
                if (phoneNumber.length !== 11 || !phoneNumber.startsWith("1")) {
                    newErrors.MobileNumber = ValidationMessages.inValidPhone;
                }
            }
            if (!FirstName || !alphabetRegex.test(FirstName)) newErrors.FirstName = ValidationMessages.firstnameAndAlphabets;
            if (!LastName || !alphabetRegex.test(LastName)) newErrors.LastName = ValidationMessages.lastnameAndAlphabets;
            if (!Title) newErrors.Title = ValidationMessages.titleAndAlphabets;
            const emailExists = await checkEmailExistence(formData.EmailId);
            if (!EmailId || !/\S+@\S+\.\S+/.test(EmailId)) {
                newErrors.EmailId = ValidationMessages.validEmail;
            }
            else if (emailExists && !props?.employeeEmailId && !isemailVerified) {
                newErrors.EmailId = ValidationMessages.emailAlredyExist;
            }
        }
        if (sec3) {
            // Case 1: None of the 3 checkboxes are checked
            if (!TandC1 && !TandC2 && !IsReitOwner) {
                newErrors.TandC2 = ValidationMessages.termsservice;
                newErrors.TandC1 = ValidationMessages.termsuse;
                newErrors.IsReitOwner = ValidationMessages.termsservice;
            } else {
                // Case 2: If IsReitOwner is selected, skip T&C checks
                if (IsReitOwner) {
                } else {
                    // Check each T&C box individually
                    if (!TandC2) newErrors.TandC2 = ValidationMessages.termsservice;
                    if (!TandC1) newErrors.TandC1 = ValidationMessages.termsuse;
                }
            }
            // Email and phone verification checks (always run)
            if (!isphoneVerified) {
                newErrors.MobileNumber = ValidationMessages.mobileVerify;
            }
            if (!isemailVerified) {
                newErrors.EmailId = ValidationMessages.emailVerify;
            }
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    const handleSubmitEmail = async (e) => {
        e.preventDefault();
        try {
            const isValid = await validateEmailandphone(true, false);
            if (isValid) {
                setLoader(true);
                await sendOTPByEmail();
            }
        } catch (error) {
            console.error('Error during form submission:', error);
        } finally {
            // Set loader to false after sendOTPByEmail completes (or an error occurs)
            setLoader(false);
        }
    };
    const handleSubmitPhone = async (e) => {
        e.preventDefault();
        try {
            const isValid = await validateEmailandphone(false, true);
            if (isValid) {
                setLoader(true);  // Set loader to true before making any request  


                // Wait for the response from sendOTPByEmail before proceeding
                await sendOTPByPhone(formData?.MobileNumber);
            }
        } catch (error) {
            console.error('Error during form submission:', error);
        } finally {
            // Set loader to false after sendOTPByEmail completes (or an error occurs)
            setLoader(false);
        }
    };

    const handleClickOpen = (type) => () => {
        let item;
        if (type === 'termsOfServices') {
            item = termsOfServicesData.termsOfServices[0];
        } else if (type === 'termsOfUses') {
            item = termsOfUsesData.termsOfUses[0];
        }
        if (item) {
            setDialogData(item);
            setOpen(true);
        } else {
            console.error("No data found.");
        }
    };

    const handleClose = () => {
        setOpen(false);
    };
    const handleCancel = () => {
        props.handleRegisterEmployee(false);
        // props.setOwnerRegistrationChanges(false);
        setErrors({});
    };


    const sendOTPByEmail = async () => {
        let EmailId = {
            EmailId: formData.EmailId
        };
        setLoader(true);
        try {
            const requestOptions = {
                method: "POST",
                headers: {
                    "x-functions-key": hostHeader,
                },
                body: JSON.stringify(EmailId),
            };
            const response = await axios.post(
                `${hostPath}/api/SendOtpToEmail`,
                requestOptions.body,
                { headers: requestOptions.headers }
            );
            if (response?.data) {
                setLoader(false);
                setEmailPopUp(true)
                setOpenmodel(true)
                setInValidOTP("")
                setOTPValidation("")
            }
        } catch (error) {
            console.error("Error sending email:", error);
        }
        finally {
            setLoader(false);
        }
    };
    const sendOTPByPhone = async (MobileNumber) => {
        setLoader(true);
        try {
            const response = await axios.post(
                `${hostPath}/api/SendOtpToSMS`,
                { CellNumber: MobileNumber },
                {
                    headers: {
                        "x-functions-key": hostHeader,
                    }
                }
            );
            if (response.data) {
                setPhoneVerification(true);
                setEmailPopUp(false);
                setOpenmodel(true);
                setInValidOTP("");
                setOTPValidation("");
            }
        } catch (error) {
            console.error("Error sending SMS:", error);
        } finally {
            setLoader(false);
        }
    };


    const handleVerify = async (otp) => {
        if (otp.length !== 5) {
            setOTPValidation(ValidationMessages.fivedigitOTP)
        } else {
            setOTPValidation("")
            const OTP = Number(otp)
            if (EmailPopUp) {
                const requestOptions = {
                    method: "POST",
                    headers: {
                        "x-functions-key": hostHeader,
                    },
                    body: JSON.stringify({
                        EmailId: formData.EmailId,
                        OTP: OTP,
                    }),
                };

                const response = await axios.post(
                    `${hostPath}/api/VerifyOtp`,
                    requestOptions.body,
                    { headers: requestOptions.headers }
                );
                if (response.data.status === true) {
                    setInValidOTP("")
                    setEmailverified(true);
                    setOpenmodel(false);
                }
                else if (response.data.status === false) {
                    setInValidOTP(response.data.responseMessage)
                }
            } else {
                const requestOptions = {
                    method: "POST",
                    headers: {
                        "x-functions-key": hostHeader,
                    },
                    body: JSON.stringify({
                        CellNumber: formData.MobileNumber,
                        OTP: OTP,
                    }),
                };
                const response = await axios.post(
                    `${hostPath}/api/VerifySMSOtp`,
                    requestOptions.body,
                    { headers: requestOptions.headers }
                );
                //If OTP is verified successfully, redirect the user to the account info page
                if (response.data && response.data.status === true) {
                    setPhoneVerified(true);
                    setInValidOTP("")
                    setOpenmodel(false)
                }
                else if (response.data.status === false) {
                    setInValidOTP(response.data.responseMessage)
                }
            }
        }
    };

    const buildEmployeePayload = ({ userId, includeB2CFlags = false }) => {
        const payload = {
            FirstName: formData.FirstName,
            LastName: formData.LastName,
            Title: formData.Title,
            EmailId: formData.EmailId,
            MobileNumber: formData.MobileNumber,
            OfficeNumber: formData.OfficeNumber,
            Password: formData.Password,
            ConfirmPassword: formData.ConfirmPassword,
            TandC1: formData.TandC1,
            TandC1CreatedDate: formData.TandC1CreatedDate,
            TandC2: formData.TandC2,
            TandC2CreatedDate: formData.TandC2CreatedDate,
            IsReitOwner: formData.IsReitOwner,
            IsReitOwnerCreatedDate: formData.IsReitOwnerCreatedDate,
            UserId: userId,
            IsEmailVerified: isemailVerified,
            IsPhoneVerified: isphoneVerified,
            EntityRegistrationID: props.userDetails?.entityRegistrationID
        };

        if (props.employeeEmailId) {
            payload.EmpRegistrationID = props.empRegistrationId;
        }
        if (props.empb2cId) {
            payload.EmpId = props.empb2cId;
        }
        if (includeB2CFlags) {
            payload.IsTempPassword = true;
        }

        return payload;
    };
    const handleRegistrationSave = async () => {
        try {
            setLoader(true);
            const isValid = await validateForm(true, formData?.IsReitOwner || formData?.TandC1 || formData?.TandC2 || props.empb2cId || false);
            console.log("enter into the try block");

            if (isValid) {
                console.log("enter into the else block");

                let updatedFormData = buildEmployeePayload({ userId: props.ownerId });
                console.log("updatedFormData", updatedFormData);

                let empRegistrationResponse;
                if (props.employeeEmailId) {
                    updatedFormData = buildEmployeePayload({ userId: props.ownerId });

                    empRegistrationResponse = await UpdateProfileByEntity(updatedFormData);
                }
                else {

                    empRegistrationResponse = await empRegistration(updatedFormData);
                    console.log("entityregistrationresponse", empRegistrationResponse);

                }
                if (empRegistrationResponse) {
                    if (empRegistrationResponse.status = true) {
                        toast.success(empRegistrationResponse.responseMessage);
                        setTimeout(() => {
                            navigate(`/EmployeeRegistrationDashboard`);
                            props.refreshEmployees();
                            props.handleRegisterEmployee(null, false);

                        }, 1000);

                    } else {
                        toast.error(empRegistrationResponse.responseMessage)
                    }

                }
            } else {
                setShowPopup(true);
            };
            //   }
        } catch (error) {
            console.error("Error in registration", error);
        } finally {
            setLoader(false);
        }
    };
    const handleRegistration = async () => {
        try {
            setLoader(true);
            const isValid = await validateForm(true, true);
            console.log("isvalid", isValid);

            if (!isValid) return;
            const updatedFormData = buildEmployeePayload({ userId: props.userDetails?.userId, includeB2CFlags: true });
            const Empdata = {
                EmpDetails: updatedFormData,
                metadata: { loginLink: resetUrl }
            };
            const b2cresponse = await EmpRegistrationB2C(Empdata);

            if (b2cresponse.status) {
                toast.success(b2cresponse.message);
                setTimeout(() => {
                    navigate(`/EmployeeRegistrationDashboard`);
                    props.refreshEmployees();
                    props.handleRegisterEmployee(null, false);
                }, 1000);
            }
            //need to add toast messsage 
        } catch (error) {
            console.error("Error in registration", error);
        } finally {
            setLoader(false);
        }
    };



    const handleResend = (type) => {
        // Logic to resend the OTP
    };
    const onClose = () => {
        setOpenmodel(false)
        setInValidOTP("")
        setOTPValidation("")

    }
    const isEditMode = Boolean(props.employeeEmailId || props.empRegistrationId || props.empb2cId);

    return (
        <div>
            {loader && (
                <div className="loader-overlay" style={{ zIndex: 1000 }}>
                    <FadeLoader />
                </div>
            )}
            <ToastContainer />
            {props.registerEmployee && (
                <div className="OwnerRegistration-Container">
                    <h4>Employee Registration</h4>
                    <form >
                        <div className="section">
                            <h5>Personal Information</h5>
                            <div className="d-flex">
                                <InputField label="First Name" name="FirstName" value={formData.FirstName} onChange={handleInputChange} error={errors.FirstName} required />
                                <InputField label="Last Name" name="LastName" value={formData.LastName} onChange={handleInputChange} error={errors.LastName} required />
                                <InputField label="Title" name="Title" value={formData.Title} error={errors.Title} required disabled={true} />
                                <div style={{ position: 'relative' }}>
                                    <InputField
                                        label="Email Address"
                                        name="EmailId"
                                        type="email"
                                        value={formData.EmailId}
                                        onChange={handleInputChange}
                                        error={errors.EmailId}
                                        required
                                        style={{
                                            width: `${Math.max(200, formData.EmailId.length * 10)}px`,
                                            paddingRight: '80px',
                                            transition: 'width 0.2s ease-in-out',
                                        }}
                                    />
                                    {isemailVerified ? (
                                        <FcCheckmark
                                            style={{
                                                position: 'absolute',
                                                top: '50%',
                                                right: '15px',
                                                transform: 'translateY(-50%)'
                                            }}
                                        />
                                    ) : (
                                        <button className='emailphoneverify-button'
                                            style={{
                                                top: '56%',
                                                right: '17px',
                                            }}
                                            onClick={handleSubmitEmail}
                                        >
                                            Verify
                                        </button>
                                    )}
                                </div>

                            </div>
                            <div className="d-flex">
                                <div style={{ position: 'relative', minHeight: '60px' }}>
                                    <label htmlFor="MobileNumber" className="loginlabel formInputs">Mobile Phone
                                        <span style={{ color: 'red', marginLeft: '4px' }}>*</span>
                                    </label>
                                    <PhoneInput
                                        international
                                        countryCallingCodeEditable={false}
                                        name="MobileNumber"
                                        maxLength={15}
                                        countries={['US']}
                                        value={formData.MobileNumber}
                                        id="MobileNumber"
                                        placeholder="Enter Your Contact Number"
                                        defaultCountry="US"
                                        onChange={(value) => handleInputChange({ target: { name: 'MobileNumber', value } })}
                                        className="Phone-Internal-Input"
                                        style={{ paddingRight: '80px', width: '250px' }}
                                    />
                                    {errors.MobileNumber && <div className="validation-error-owner">{errors.MobileNumber}</div>}

                                    {isphoneVerified ? (
                                        <FcCheckmark
                                            style={{
                                                position: 'absolute',
                                                top: '68%',
                                                right: '15px',
                                                transform: 'translateY(-50%)'
                                            }}
                                        />
                                    ) : (
                                        <button className='emailphoneverify-button'
                                            style={{
                                                top: '70%',
                                                right: '10px',
                                            }}
                                            onClick={handleSubmitPhone}
                                        >
                                            Verify
                                        </button>
                                    )}
                                </div>

                                <div>
                                    <label htmlFor="OfficeNumber" className="loginlabel formInputs">Office Phone</label>
                                    <PhoneInput
                                        international
                                        countryCallingCodeEditable={false}
                                        name="OfficeNumber"
                                        maxLength={15}
                                        countries={['US']}
                                        value={formData.OfficeNumber}
                                        id="OfficeNumber"
                                        placeholder="Enter Office Contact Number"
                                        defaultCountry="US"
                                        onChange={(value) => handleInputChange({ target: { name: 'OfficeNumber', value } })}
                                        className="Phone-Internal-Input"
                                    />
                                    {errors.OfficeNumber && <div className="validation-error-owner">{errors.OfficeNumber}</div>}
                                </div>
                            </div>

                            <div className="d-flex flex-nowrap justify-content-start align-items-start" style={{ overflowX: 'auto', width: '100%' }}>
                                <div className="d-flex flex-column me-4" style={{ minWidth: '250px' }}>
                                    <div className="remembercheckbox">
                                        <label className="control control--checkbox mb-1">
                                            <input
                                                type="checkbox"
                                                checked={formData.TandC1}
                                                disabled={true}
                                            />
                                            <span className="ms-1">
                                                I Agree to
                                                <a className="joingeo ms-1" onClick={handleClickOpen("termsOfUses")}>
                                                    Terms of Use
                                                </a>
                                            </span>
                                            <div className="control__indicator"></div>
                                        </label>
                                        {errors.TandC1 && (
                                            <div className="error-message mandatorymark">{errors.TandC1}</div>
                                        )}
                                        {formData.TandC1 && (
                                            <>
                                                <label className="checked-by-label">
                                                    Checked by: {props.userDetails?.firstName} {props.userDetails?.lastName}
                                                </label>
                                                <label>
                                                    Date: {
                                                        formData.TandC1CreatedDate
                                                            ? new Date(formData.TandC1CreatedDate).toLocaleDateString('en-US')
                                                            : todayDate instanceof Date
                                                                ? `${String(todayDate.getMonth() + 1).padStart(2, '0')}/${String(todayDate.getDate()).padStart(2, '0')}/${todayDate.getFullYear()}`
                                                                : todayDate
                                                    }
                                                </label>
                                            </>
                                        )}
                                    </div>
                                </div>

                                <div className="d-flex flex-column me-4" style={{ minWidth: '250px' }}>
                                    <div className="remembercheckbox">
                                        <label className="control control--checkbox mb-1">
                                            <input
                                                type="checkbox"
                                                checked={formData.TandC2}
                                                disabled={true}
                                            />
                                            <span className="ms-1">
                                                I Agree to
                                                <a className="joingeo ms-1" onClick={handleClickOpen("termsOfServices")}>
                                                    Terms of Service
                                                </a>
                                            </span>
                                            <div className="control__indicator"></div>
                                        </label>
                                        {errors.TandC2 && (
                                            <div className="error-message mandatorymark">{errors.TandC2}</div>
                                        )}
                                        {formData.TandC2 && (
                                            <>
                                                <label className="checked-by-label">
                                                    Checked by: {props.userDetails?.firstName} {props.userDetails?.lastName}
                                                </label>
                                                <label>
                                                    Date: {
                                                        formData.TandC2CreatedDate
                                                            ? new Date(formData.TandC2CreatedDate).toLocaleDateString('en-US')
                                                            : todayDate instanceof Date
                                                                ? `${String(todayDate.getMonth() + 1).padStart(2, '0')}/${String(todayDate.getDate()).padStart(2, '0')}/${todayDate.getFullYear()}`
                                                                : todayDate
                                                    }
                                                </label>
                                            </>
                                        )}
                                    </div>
                                </div>

                                <div className="d-flex flex-column" style={{ minWidth: '300px' }}>
                                    <div className="remembercheckbox3">
                                        <div className="mb-1 text-center w-100"><b>REIT</b></div>
                                        <label className="control control--checkbox mb-1 reit-checkbox-label">
                                            <input
                                                type="checkbox"
                                                checked={formData?.IsReitOwner}
                                                disabled={true}
                                            />
                                            <span className="ms-1">
                                                I Agree to
                                                <a className="joingeo ms-1" onClick={handleClickOpen("termsOfServices")}>
                                                    Terms of Service
                                                </a>
                                            </span>
                                            <div className="control__indicator"></div>
                                        </label>
                                        {errors.IsReitOwner && (
                                            <div className="error-message mandatorymark">{errors.IsReitOwner}</div>
                                        )}
                                        {formData.IsReitOwner && (
                                            <>
                                                <label className="checked-by-label">
                                                    Checked by: {props.userDetails?.firstName} {props.userDetails?.lastName}
                                                </label>
                                                <div className="mb-1">
                                                    <label>Date: </label>
                                                    <span>
                                                        {formData.IsReitOwnerCreatedDate
                                                            ? new Date(formData.IsReitOwnerCreatedDate).toLocaleDateString('en-US')
                                                            : todayDate instanceof Date
                                                                ? `${String(todayDate.getMonth() + 1).padStart(2, '0')}/${String(todayDate.getDate()).padStart(2, '0')}/${todayDate.getFullYear()}`
                                                                : todayDate}
                                                    </span>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <BootstrapDialog
                            open={open}
                            onClose={handleClose}
                            title={`${dialogData.title}`}
                            content={dialogData.sections}
                            lastModified={`${dialogData.lastModified}`}
                            setOpen={setOpen}
                        />
                        {
                            < BootstrapDialogpopup
                                EmailPopUp={EmailPopUp}
                                open={openpopup}
                                initialEmail={EmailPopUp ? formData.EmailId : formData.MobileNumber}
                                destinationType={EmailPopUp ? "Email" : "MobileNumber"}
                                onVerify={handleVerify}
                                onResend={handleResend}
                                onClose={onClose}
                                InValidOTP={InValidOTP}
                                OTPValidation={OTPValidation}
                                sendOTPByEmail={sendOTPByEmail}
                                sendOTPByPhone={sendOTPByPhone} />
                        }

                        <div className="button-group">
                            <button type="button" className="cancel-button" onClick={handleCancel}>Cancel</button>
                            {isEditMode ?
                                <button
                                    type="button"
                                    className={`submit-button ${!(isphoneVerified && isemailVerified) ? 'enabled' : 'disabled'}`}
                                    title={!(isphoneVerified && isemailVerified) ? 'Email and phone verification needs to be done' : ''}
                                    onClick={() => { handleRegistrationSave() }}
                                >
                                    Update
                                </button>
                                :
                                (<button
                                    type="button"
                                    className={`submit-button ${!(isphoneVerified && isemailVerified) ? 'enabled' : 'disabled'}`}
                                    title={!(isphoneVerified && isemailVerified) ? 'Email and phone verification needs to be done' : ''}
                                    onClick={() => { handleRegistrationSave() }}
                                >
                                    Save
                                </button>)
                            }
                            {!isEditMode &&
                                <button
                                    type="button"
                                    className={`submit-button ${isphoneVerified && isemailVerified ? 'enabled' : 'disabled'}`}
                                    title={!(isphoneVerified && isemailVerified) ? 'Email and phone verification needs to be done' : ''}
                                    onClick={() => { handleRegistration() }}
                                >
                                    Register
                                </button>
                            }

                        </div>
                    </form>
                </div >

            )}
        </div >
    );
};

// Reusable Input Field Component
const InputField = ({
    label,
    name,
    value,
    onChange,
    error,
    type = "text",
    required,
    autoComplete,
    readOnly,
    disabled,
    className
}) => (
    <div className={`form-field mb-4 ${name}`}>
        <label htmlFor={name} className="loginlabel">
            {label} {required && <span className="mandatorymark">*</span>}
        </label>
        <input
            type={type}
            name={name}
            id={name}
            value={value}
            onChange={onChange}
            placeholder={`Enter ${label}`}
            autoComplete={autoComplete}
            readOnly={readOnly}
            disabled={disabled}
            className={className}
            style={{
                cursor: disabled ? "not-allowed" : "text", // ✅ show disabled symbol
                backgroundColor: disabled ? "white" : "white" // ✅ optional: greyed background
            }}
        />
        {error && <div className="validation-error-owner">{error}</div>}
    </div>
);

export default EmployeeRegistration